"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Mutations = __importStar(require("./mutations"));

exports.Mutations = Mutations;

var Requests = __importStar(require("./requests"));

exports.Requests = Requests;

var Resources = __importStar(require("./resources"));

exports.Resources = Resources;

__export(require("./common"));

__export(require("./permissions"));